import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { OtherDocumentsPage } from '@/features/other-documents/other-documents'
import { usePanelStore } from '@/components/conversation/panel-store'

export const Route = createFileRoute('/_layout/_app/other-documents/$id')({
  component: OtherDocumentsRoute,
  staticData: { title: 'Ostali dokumenti' },
})

function OtherDocumentsRoute() {
  const { id } = Route.useParams()
  const closePanel = usePanelStore((s) => s.closePanel)

  useEffect(() => {
    closePanel(true)
  }, [id, closePanel])

  useEffect(() => {
    return () => closePanel(true)
  }, [closePanel])

  return <OtherDocumentsPage id={id} />
}
